import { Expose, Type } from "class-transformer";
import type { RealEstateBuildingMacroCategoryEnum } from "../../constants/real-estate/real-estate-building-macro-category.enum";
import type { RealEstateBuildingTypeEnum } from "../../constants/real-estate/real-estate-building-type.enum";
import type { RealEstateCategoryEnum } from "../../constants/real-estate/real-estate-category.enum";
import { RealEstateRelationship } from "./real-estate-relationship.entity";

export class RealEstate {
  @Expose()
  id!: string;

  @Expose()
  realEstateCategory?: RealEstateCategoryEnum;

  @Expose()
  realEstateBuildingMacroCategory?: RealEstateBuildingMacroCategoryEnum;

  @Expose()
  realEstateBuildingType?: RealEstateBuildingTypeEnum;

  @Expose()
  realEstateGeographyCountry?: string;

  @Expose()
  realEstateGeographyMunicipality?: string;

  @Expose()
  realEstateGeographyProvince?: string;

  @Expose()
  realEstateGeographyRegion?: string;

  @Expose()
  @Type(() => RealEstateRelationship)
  relationship!: RealEstateRelationship;

  @Expose()
  realEstateLabel?: string;

  @Expose()
  isComplete!: boolean;

  public isMainHome(): boolean {
    return this.relationship?.realEstateMainHome === true;
  }
}
